<!-- App footer -->
<template>
  <div v-if="this.$store.state.footerVisible" class="row center-xs middle-xs footer">
    <!-- Social media -->
    <div class="col-xs-5 start-md">
      <a target="_blank" href="https://www.facebook.com/designtoimprovelife/">
        <fa-icon :icon="['fab', 'facebook-f']" />
      </a>
      <a target="_blank" href="https://twitter.com/indexaward">
        <fa-icon :icon="['fab', 'twitter']" />
      </a>
      <a target="_blank" href="https://www.instagram.com/designtoimprovelife/">
        <fa-icon :icon="['fab', 'instagram']" />
      </a>
      <a target="_blank" href="https://www.flickr.com/photos/iaward/albums">
        <fa-icon :icon="['fab', 'flickr']" />
      </a>
    </div>
    <!-- Privacy policy -->
    <div class="col-xs-5 end-md">
      <router-link to="/privacy-policy">Privacy Policy</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped>
.footer {
  background-color: var(--black);
  height: 4.5vw;
  color: var(--white);
  font-size: var(--vw15px);
}
@media only screen and (max-width: 767px) {
  /* MOBILE */
  .footer {
    height: 18vw !important;
  }
}
a {
  text-decoration: none;
  color: var(--white);
  margin: 0 10px 0 10px;
}
a:hover {
  color: var(--grey200);
}
</style>